import { render, staticRenderFns } from "./appClassifyDialog.vue?vue&type=template&id=01bbde4e&"
import script from "./appClassifyDialog.vue?vue&type=script&lang=js&"
export * from "./appClassifyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports